import { render, staticRenderFns } from "./flowConfig01FlowListComponent.vue?vue&type=template&id=ff5ac83a&scoped=true&"
import script from "./flowConfig01FlowListComponent.vue?vue&type=script&lang=js&"
export * from "./flowConfig01FlowListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5ac83a",
  null
  
)

export default component.exports